<!-- 关注商家、商品收藏、浏览记录、投诉与反馈、询价记录 -->
<template>
	<div class="product-page">
		<!-- Category Filters -->
		<div class="category-filters">
			<div v-for="category in categories" :key="category.name" class="category-filter"
				:class="{ active: category.active }" @click="selectCategory(category)">
				{{ category.name }}
			</div>
		</div>
		<!-- Search Bar -->
		<div class="search-container">
			<div class="search-wrapper">
				<div class="custom-search-input">
					<el-input type="text" :placeholder="$t('searchKeyword')" v-model="searchKeyword"
						class="search-input" @keyup.enter.native="search" />
					<button class="search-button" @click="search">{{ $t('search') }}</button>
				</div>
			</div>
		</div>

		<MerchantList :search-keyword="searchKeyword" ref="merchantList" v-if="selectKey=='followedMerchants'"
			source="follow" />
		<ProductListForCollection ref="productList" v-if="selectKey=='productFavorites'||selectKey=='browsingHistory'"
			:source="source" :search-keyword="searchKeyword"/>
		<ComplaintList ref="complaintList" v-if="selectKey=='complaintsFeedback'" :searchKeyword="searchKeyword" />
		<EnquiryList ref="enquiryList" v-if="selectKey=='inquiryRecords'" :searchKeyword="searchKeyword" />
		<!-- 右边悬浮固定栏相关组件 -->
		<RightFixedPanel @openEnquiry="enquiryDialogVisible = true" @openComplaint="complaintDialogVisible = true" />
		<EnquiryDialog :visible.sync="enquiryDialogVisible" @save-callback="search" />
		<ComplaintDialog :visible.sync="complaintDialogVisible" />
	</div>
</template>

<script>
	import MerchantList from '@/components/MerchantList.vue';
	import ProductListForCollection from '@/components/ProductListForCollection.vue';
	import ComplaintList from '@/components/ComplaintList.vue';
	import EnquiryList from '@/components/EnquiryList.vue';
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import EnquiryDialog from '@/components/EnquiryDialog.vue';
	import ComplaintDialog from '@/components/ComplaintDialog.vue';
	export default {
		name: 'Follow',
		components: {
			MerchantList,
			ProductListForCollection,
			ComplaintList,
			EnquiryList,
			RightFixedPanel,
			EnquiryDialog,
			ComplaintDialog
		},
		data() {
			return {
				source: '',
				enquiryDialogVisible: false,
				complaintDialogVisible: false,
				searchKeyword: '',
				selectKey: 'followedMerchants',
				categoryActiveStates: {
					followedMerchants: true,
					productFavorites: false,
					browsingHistory: false,
					complaintsFeedback: false,
					inquiryRecords: false
				},
			}
		},
		// 计算属性，根据当前语言和活跃状态动态生成分类列表
		computed: {
			categories() {
				return [{
					key: 'followedMerchants',
					name: this.$t('followedMerchants'),
					active: this.categoryActiveStates.followedMerchants
				}, {
					key: 'productFavorites',
					name: this.$t('productFavorites'),
					active: this.categoryActiveStates.productFavorites
				}, {
					key: 'browsingHistory',
					name: this.$t('browsingHistory'),
					active: this.categoryActiveStates.browsingHistory
				}, {
					key: 'complaintsFeedback',
					name: this.$t('complaintsFeedback'),
					active: this.categoryActiveStates.complaintsFeedback
				}, {
					key: 'inquiryRecords',
					name: this.$t('inquiryRecords'),
					active: this.categoryActiveStates.inquiryRecords
				}];
			}
		},
		mounted() {
			// 从路由参数获取默认选中的选项卡
			if (this.$route.query.type) {
				const type = this.$route.query.type
				// 检查类型是否有效
				if (this.categoryActiveStates.hasOwnProperty(type)) {
					// 设置对应的选项卡为激活状态
					this.selectCategory({
						key: type
					})
				}
			}
		},
		watch: {
			'$i18n.locale': {
				handler(newLocale, oldLocale) {
					console.log('Language changed from', oldLocale, 'to', newLocale);
				},
				immediate: false // 不立即执行，只在变化时执行
			},
			// 监听路由参数变化
			'$route.query.type': {
				handler(newType, oldType) {
					console.log('Type changed from', oldType, 'to', newType);
					// 当type参数变化时，设置对应的分类为活跃状态
					if (newType && this.categoryActiveStates.hasOwnProperty(newType)) {
						this.selectCategory({
							key: newType
						});
					}
				},
				immediate: false // 不立即执行，只在变化时执行
			}
		},
		methods: {
			//获取关注商家
			loadMerchant() {
				this.$nextTick(() => {
					if (this.$refs.merchantList && typeof this.$refs.merchantList.init === 'function') {
						this.$refs.merchantList.init();
					}
				});
			},
			//加载商品收藏、浏览记录
			loadGoods() {
				this.$nextTick(() => {
					if (this.$refs.productList && typeof this.$refs.productList.init === 'function') {
						this.$refs.productList.init();
					}
				})
			},
			//加载询价记录
			loadInquiry() {
				this.$nextTick(() => {
					if (this.$refs.enquiryList && typeof this.$refs.enquiryList.init === 'function') {
						this.$refs.enquiryList.init();
					}
				})
			},
			//加载投诉记录
			loadComplaint() {
				this.$nextTick(() => {
					if (this.$refs.complaintList && typeof this.$refs.complaintList.init === 'function') {
						this.$refs.complaintList.init();
					}
				})
			},
			handleDetail() {
				// 跳转到商家内页
				this.$router.push({
					path: '/merchant-detail',
					query: {
						keyword: this.searchKeyword.trim()
					}
				})
			},
			search() {
				if (this.selectKey == 'followedMerchants') {
					this.loadMerchant();
				}
				if (this.selectKey == 'productFavorites' || this.selectKey == 'browsingHistory') {
					this.source = this.selectKey == 'productFavorites' ? 'collection' : 'footprint'
					this.loadGoods();
				}
				//获取询价记录
				if (this.selectKey == 'inquiryRecords') {
					this.loadInquiry();
				}
				//获取投诉记录
				if (this.selectKey == 'complaintsFeedback') {
					this.loadComplaint();
				}
			},
			// 切换分类
			selectCategory(category) {
				// 先将所有分类的active状态设置为false
				Object.keys(this.categoryActiveStates).forEach(key => {
					this.categoryActiveStates[key] = false;
				});
				// 将点击的分类的active状态设置为true
				this.categoryActiveStates[category.key] = true;
				this.selectKey = category.key;
				this.search();
			},
		}
	}
</script>

<style scoped>
	.product-page {
		padding: 0;
		max-width: 1200px;
		margin: 0 auto;
	}

	.category-filters {
		padding: 0 20px;
		display: flex;
		margin-top: 20px;
		flex-wrap: nowrap;
		overflow-x: auto;
		/* 默认隐藏滚动条 */
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
	}

	/* 鼠标移入时显示滚动条 */
	.category-filters:hover {
		scrollbar-color: #ccc transparent;
	}

	/* WebKit浏览器滚动条样式 */
	.category-filters::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	.category-filters::-webkit-scrollbar-track {
		background: transparent;
	}

	.category-filters::-webkit-scrollbar-thumb {
		background-color: transparent;
		border-radius: 3px;
	}

	.category-filters:hover::-webkit-scrollbar-thumb {
		background-color: #ccc;
	}

	.category-filter {
		padding: 20px 30px;
		min-width: 200px;
		text-align: center;
		color: #333;
		cursor: pointer;
		font-size: 17px;
		transition: all 0.3s ease;
		flex-shrink: 0;
		white-space: nowrap;
	}

	.category-filter.active {
		background-color: #016AF8;
		font-weight: bold;
		color: white;
	}

	.category-filter:hover {
		background-color: #E6F1FE;
		color: #016AF8;
	}

	.category-filter.active:hover {
		background-color: #0156c8;
		color: #fff;
	}

	/* Search bar styles */
	.search-container {
		display: flex;
		justify-content: center;
		z-index: 10;
	}

	.search-wrapper {
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: 10px;
	}

	.custom-search-input {
		display: flex;
		align-items: center;
		border-radius: 10px;
		width: 100%;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 0.05);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		border: 2px solid #F59A23;
	}

	.search-button {
		background-color: #F59A23;
		color: white;
		border: none;
		height: 50px;
		width: 160px;
		cursor: pointer;
		font-size: 17px;
		transition: background-color 0.3s;
	}

	:deep .el-input__inner {
		background-color: transparent !important;
		border: 0 solid #DCDFE6;
		font-size: 16px;
		color: #000;
	}

	.search-button:hover {
		background-color: #F59A23;
	}

	/* Ensure proper spacing between elements */
	.product-page {
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}

	/* Make buttons match Element UI styles */
	:deep .el-button--primary.is-plain {
		border-color: #016AF8;
		color: #016AF8;
	}

	:deep .el-button--primary.is-plain:hover {
		background-color: #016AF8;
		color: #fff;
	}
</style>